import React from "react";
import Layout from "../../components/Layout/Layout";
import Questionnaire from "../../components/pages/YoungDesigners/Questionnaire/Questionnaire";
import Feedback from "../../components/general/Feedback/Feedback";

const YoungDesignersPage: React.FC = () => {
  return (
    <Layout>
      <Questionnaire />
      <Feedback />
    </Layout>
  );
};

export default YoungDesignersPage;
